/** Product name shown in the UI. The final name is still open (see requirements, Risks). */
export const APP_NAME = 'fixed';

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string | undefined;
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

/**
 * Without Supabase keys, sign-in runs as a local demo account so the My Artists flow can be
 * tried and tested. Only in dev builds, or when explicitly enabled (e2e builds).
 */
export const DEMO_AUTH =
  !(SUPABASE_URL && SUPABASE_ANON_KEY) && (import.meta.env.DEV || import.meta.env.VITE_DEMO_AUTH === '1');

export const AUTH_CONFIGURED = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY) || DEMO_AUTH;

/** The Discover Weekly playlist that Google links to for "spotify weekly". */
export const DISCOVER_WEEKLY_URL = 'https://open.spotify.com/playlist/37i9dQZEVXcQ9COmYvdajy';

export const SITE_URL = 'https://fixed-albums.pages.dev';

/** Shown on the privacy and terms pages. Empty hides the contact line. */
export const CONTACT_EMAIL = '';

/** Date the privacy policy and terms last changed. */
export const POLICIES_UPDATED = 'October 15, 2026';
